/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { OrganizationStatus } from 'reducers/organizations/OrganizationState';
import { fetchOrganizationsThunk } from 'actions/organization/OrganizationActions';
import { useAuth } from './useAuth';

// Organization the portal works on: the parent organization, else the first one, else the user's.
// Same resolution the Sales Dashboard uses; loads the organizations when they aren't loaded yet.
export const useOrganizationId = (): number | undefined => {
    const dispatch = useDispatch();
    const auth = useAuth();
    const { organizations, status } = useSelector((state: RootState) => state.organizations);

    useEffect(() => {
        if (status === OrganizationStatus.Initial) {
            dispatch(fetchOrganizationsThunk() as any);
        }
    }, [dispatch, status]);

    if (organizations && organizations.length > 0) {
        const parent = organizations.find(organization => organization.parentOrganizationId == null);
        return (parent ?? organizations[0]).id;
    }

    return (auth?.user as any)?.organizationId ?? undefined;
};

export default useOrganizationId;
